import { Injectable } from '@angular/core';
import { InveniasEntityTypes } from 'datasource-service-lib';
import { Namespace } from 'enums-lib';
import { EntityType, IDataSourceApiService, IEntity, IEntityPickerService, IIconService } from 'interfaces-lib';
import { IPickerInfo } from 'interfaces-lib';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

interface IInveniasAggregateQueryEntity extends IEntity {
  CompanyName: string;
  DisplayName: string;
  ItemId: string;
  JobTitle: string;
  RecordPictureUri?: string;
}

@Injectable({ providedIn: 'root' })
export class InveniasEntityPickerService implements IEntityPickerService {
  private apiService: IDataSourceApiService;
  private iconService: IIconService;
  private searchEntityTypes: EntityType[] = [
    InveniasEntityTypes.People,
    InveniasEntityTypes.Companies,
    InveniasEntityTypes.Programmes,
    InveniasEntityTypes.Assignments,
  ];

  constructor(serviceProviderServiceFactory: SharedServiceProviderServiceFactory) {
    const sps = serviceProviderServiceFactory.getServiceProviderService(Namespace.invenias);
    this.apiService = sps.getDataSourceApiService();
    this.iconService = sps.getIconService();
  }

  findMatches(searchTerm: string, searchTypes?: EntityType[]): Observable<IPickerInfo[]> {
    const obs: Observable<IPickerInfo[]>[] = [];
    this.searchEntityTypes
      .filter((searchEntity) => !searchTypes || searchTypes.includes(searchEntity))
      .forEach((entityType) => {
        const query$ = this.apiService.query(entityType, { searchTerm });
        const mapper$ = query$.pipe(map((entities) => entities.map((entity) => this.transform(entity as IInveniasAggregateQueryEntity))));
        obs.push(mapper$);
      });

    const queries$ = zip(...obs);

    return queries$.pipe(
      map((resultsByEntityType: any[][]) => {
        const flat: any[] = [];
        resultsByEntityType.forEach((r) => flat.push(...r));
        return flat;
      })
    );
  }

  private transform(entity: IInveniasAggregateQueryEntity): IPickerInfo {
    return {
      entity: { ...entity, name: entity.DisplayName }, // force to match the INamedEntity interface for file-list-view to work
      icon: this.iconService.getIcon(entity.type),
      label: entity.DisplayName,
      showId: false,
      details: entity.JobTitle ? entity.JobTitle + ', ' + entity.CompanyName : entity.CompanyName,
    };
  }
}
